import { icon } from '@jupiterone/jupiter-web-toolkit';
import NodeIcon from 'jupiter-graph-viewer/src/components/NodeIcon/NodeIcon';
import {
  GraphEdge,
  GraphVertex,
  J1ToGraphConverterProps,
  VisEdge,
  VisNode,
} from 'jupiter-graph-viewer/src/components/types';
import { reactToSvgImageUrl } from 'jupiter-graph-viewer/src/components/utils/svg';
import getVisEdgeColor from 'jupiter-graph-viewer/src/components/VisEdgeArrow/getVisEdgeColor';

// copied, refactor me
const convertVertexToVisNode = (
  vertex: GraphVertex,
  { selectedNodeId, unrelatedNodeIds }: J1ToGraphConverterProps
): VisNode => {
  const label = vertex.entity?.displayName || '';
  const iconPath = icon.entityToPath(vertex.entity);
  const loadedIcon = icon.get(iconPath);
  const selected = selectedNodeId === vertex.id;
  const visNode: VisNode = {
    id: vertex.id,
    iconPath,
    label: label,
    size: 25,
    shape: 'image',
    opacity: 1,
    image: reactToSvgImageUrl(NodeIcon({ vertex, icon: loadedIcon, selected })),
  };
  if (
    selectedNodeId !== vertex.id &&
    unrelatedNodeIds?.find((id) => id === vertex.id)
  ) {
    visNode.opacity = 0.5;
  }
  return visNode;
};

// copied, refactor me
const convertEdgeToVisEdge = (
  edge: GraphEdge,
  { selectedNodeId, selectedEdgeId }: J1ToGraphConverterProps
): VisEdge => {
  const displayName = edge.relationship.displayName;
  // Setting an empty label causes the update to ignore it and keeps the original label
  // This means we need to hide it via font size
  const label =
    selectedEdgeId === edge.id ||
    selectedNodeId === edge.fromVertexId ||
    selectedNodeId === edge.toVertexId
      ? displayName || edge.relationship._class || ''
      : '';
  const visEdge: VisEdge = {
    id: edge.id,
    from: edge.fromVertexId,
    to: edge.toVertexId,
    label,
    font: label === '' ? { size: 0 } : { size: 10 },
    color: getVisEdgeColor({ displayName }),
  };
  return visEdge;
};

const j1ToVisConverter = (
  vertices: GraphVertex[],
  edges: GraphEdge[],
  converterArgs: J1ToGraphConverterProps
): { nodes: VisNode[]; edges: VisEdge[] } => ({
  nodes: vertices.map((v) => convertVertexToVisNode(v, converterArgs)),
  edges: edges.map((e) => convertEdgeToVisEdge(e, converterArgs)),
});

export default j1ToVisConverter;
